/**
 * @typedef {import('../../../../App/shared/SubscriptionService/CheckoutSession').default} CheckoutSession
 * @typedef {{isGettingData: boolean; data: string|null}} Response
 */

import { subscriptionService } from '../../../../service-container';
import { useEffect, useMemo, useState } from 'react';
import captureError from '../../../../utils/captureError';
import useGetAgentSubscription from '../useGetAgentSubscription/useGetAgentSubscription';

/** @returns {Response} */
export default function useAgentSubscriptionManagementLink() {
	const subscription = useGetAgentSubscription();
	const [link, setLink] = useState(/** @type {string | null} */ (null));
	const [isGettingData, setIsGettingData] = useState(true);

	useEffect(() => {
		if (!subscription.data?.isActive && !subscription.data?.isRenewing) {
			setIsGettingData(false);
			return;
		}

		getCheckoutLinks();
	}, [subscription.isGettingData]);

	async function getCheckoutLinks() {
		setIsGettingData(true);

		try {
			const managementSession =
				await subscriptionService.getAgentSubscriptionManagementLink();

			setLink(managementSession.url);
		} catch (error) {
			captureError(error);
		} finally {
			setIsGettingData(false);
		}
	}

	return useMemo(
		() => ({
			data: link,
			isGettingData,
		}),
		[isGettingData, link]
	);
}
